import { render, staticRenderFns } from "./view.vue?vue&type=template&id=21335b40&scoped=true&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"
import style0 from "./view.vue?vue&type=style&index=0&id=21335b40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21335b40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21335b40')) {
      api.createRecord('21335b40', component.options)
    } else {
      api.reload('21335b40', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=21335b40&scoped=true&", function () {
      api.rerender('21335b40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/patrolWorkOrderMgr/mobile/view.vue"
export default component.exports